import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class QrCodeTrackingCookieService {
  private readonly CookiePrefix = 'qr_job_';

  constructor(private readonly cookieService: CookieService) {}

  getQrCodeId(jobOpportunityId: string): string | null {
    if (!jobOpportunityId) return null;

    const normalizedJobId = jobOpportunityId.replace(/-/g, '').toLowerCase();
    const cookieName = `${this.CookiePrefix}${normalizedJobId}`;

    if (!this.cookieService.check(cookieName)) return null;

    return this.cookieService.get(cookieName) || null;
  }
}
